"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Toast_1 = __importDefault(require("@/components/Toast"));
function UsersToastView({ isOpen, onClose, severity, message, anchorOrigin, }) {
    return (react_1.default.createElement(Toast_1.default, { isOpen: isOpen, severity: severity, onClose: onClose, message: message, anchorOrigin: anchorOrigin, closeText: "X" }));
}
exports.default = UsersToastView;
